import moment from 'moment';

export default {
  format(duration) {
    const d = moment.duration(duration);
    return d.format('HH:mm:ss', { trim: false });
  }
};
